function showInstallmentPlans() {
    modals.openModal(null, '#installment-plan')
}
